import React from 'react';
import i18n from '../../../i18n';
import swal from 'sweetalert';
import { updateMeeting } from '../../../models/meetings';
import { getAllOfficers } from '../../../models/officers';
import Select from "react-select";

let lang = localStorage.getItem('I18N_LANGUAGE');
class EditMeeting extends React.Component {
  constructor() {
    super();
    this.state = {
      input: {},
      errors: {},
      officers: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.loadOfficers();
    let { meeting } = this.props;
    let groupIds = [];
    if (meeting.groups && meeting.groups.length > 0) {
      groupIds = meeting.groups.map((group) => group.id);
    }

    this.setState({
      input: {
        ...meeting,
        group: groupIds,
      },
    });
  }

  async loadOfficers() {
    this.setState({ officers_loading: true });
    const response = await getAllOfficers();
    if (response.success) {
      let officers = response.data;
      this.setState({ officers });
      this.setState({ officers_loading: false });
    }
  }

  handleChange(event) {
    let input = this.state.input;
    if (event.target.multiple) {
      const selected = Array.from(event.target.selectedOptions).map((option) => option.value);
      input[event.target.name] = selected;
    } else {
      input[event.target.name] = event.target.value;
    }
    this.setState({ input });
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.validate()) {
      try {
        let { input } = this.state;
        input.start_time = input.start_time.substring(0, 5);
        input.end_time = input.end_time.substring(0, 5);
        let { id } = this.props;

        const response = await updateMeeting(input, id);
        if (response.success) {
          swal(i18n.t('success'), 'Meeting created successfully!!', 'success', {
            buttons: false,
            timer: 2000,
          })
            .then((value) => {
              this.resetForm();
              this.props.onReload({
                screen_val: '2',
                meetingID: response?.data?.id,
              });
            })
            .catch((response) => {
              swal('Failed', response.message, 'error');
            });
        } else {
          let error_message = response.message;
          // let resObject = response.data;
          // for (const key in resObject) {
          //   if (Object.hasOwnProperty.call(resObject, key)) {
          //     let element = resObject[key];
          //     error_message += '\n' + element;
          //   }
          // }
          swal('Failed', error_message, 'error');
        }
      } catch (err) {
        console.log(err);
      }
    }
  }

  validate() {
    let { input } = this.state;
    let errors = {};
    let isValid = true;
    if (!input['group']) {
      isValid = false;
      errors['group'] = 'Please select group.';
    }
    if (!input['title']) {
      isValid = false;
      errors['title'] = 'Please enter title.';
    }

    if (!input['title_ar']) {
      isValid = false;
      errors['title_ar'] = 'Please enter title(arabic).';
    }

    if (!input['number']) {
      isValid = false;
      errors['number'] = 'Please enter number.';
    }

    if (!input['number_ar']) {
      isValid = false;
      errors['number_ar'] = 'Please enter number(arabic).';
    }

    if (!input['date']) {
      isValid = false;
      errors['date'] = 'Please enter date.';
    }

    this.setState({
      errors: errors,
    });
    return isValid;
  }

  resetForm() {
    let { input } = this.state;
    input = {};
    this.setState({ input: input });
  }

  render() {
    let { groups } = this.props;
    let { officers } = this.state;
    return (
      <React.Fragment>
        <div className="row">
          <div className="single-page">
            <div className="col-md-12 d-block mx-auto">
              <div className="wrapper wrapper2">
                <form id="add_form" className="card-body" tabIndex="500" autoComplete="off">
                  <div className="row">
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{i18n.t('group')}</label>
                        {/* <select
                          className="form-control"
                          name="group"
                          multiple
                          value={this.state.input.group}
                          onChange={this.handleChange}
                        >
                          <option value="">-- {i18n.t('group')} --</option>
                          {groups.length > 0 &&
                            groups.map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {lang === 'ar' ? item.group_name_ar : item.group_name}
                                </option>
                              );
                            })}
                        </select> */}

                        <Select
                          isMulti
                          name="group"
                          options={groups.map((item) => ({
                            value: item.id,
                            label: lang === "ar" ? item.group_name_ar : item.group_name,
                          }))}
                          value={
                            groups
                              .filter((item) => this.state.input.group?.includes(item.id))
                              .map((item) => ({
                                value: item.id,
                                label: lang === "ar" ? item.group_name_ar : item.group_name,
                              }))
                          }
                          onChange={(selectedOptions) => {
                            this.handleChange({
                              target: {
                                name: "group",
                                value: selectedOptions.map((opt) => opt.value),
                              },
                            });
                          }}
                          className="basic-multi-select"
                          classNamePrefix="select"
                        />
                        <div className="text-danger">{this.state.errors.group}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{i18n.t('final_approved_officer')}</label>
                        <select
                          className="form-control"
                          name="final_approved_officer"
                          value={this.state.input.final_approved_officer}
                          onChange={this.handleChange}
                        >
                          <option value="">-- {i18n.t('final_approved_officer')} --</option>
                          {officers.length > 0 &&
                            officers.map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {lang === 'ar' ? item.name_ar : item.name}(
                                  {lang === 'ar' ? item?.rank_info?.rank_ar : item?.rank_info?.rank_en})
                                </option>
                              );
                            })}
                        </select>
                        <div className="text-danger">{this.state.errors.final_approved_officer}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">{i18n.t('title')}</label>
                        <input
                          type="text"
                          name="title"
                          value={this.state.input.title}
                          onChange={this.handleChange}
                          style={{ direction: 'ltr' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.title}</div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('title')}({i18n.t('arabic')})
                        </label>
                        <input
                          type="text"
                          name="title_ar"
                          value={this.state.input.title_ar}
                          onChange={this.handleChange}
                          style={{ direction: 'rtl' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.title_ar}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('meeting')} {i18n.t('number')}
                        </label>
                        <input
                          type="text"
                          name="number"
                          value={this.state.input.number}
                          onChange={this.handleChange}
                          style={{ direction: 'ltr' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.number}</div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('meeting')} {i18n.t('number')}({i18n.t('arabic')})
                        </label>
                        <input
                          type="text"
                          name="number_ar"
                          value={this.state.input.number_ar}
                          onChange={this.handleChange}
                          style={{ direction: 'rtl' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.number_ar}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('meeting')} {i18n.t('location')}
                        </label>
                        <input
                          type="text"
                          name="location"
                          value={this.state.input.location}
                          onChange={this.handleChange}
                          style={{ direction: 'ltr' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.location}</div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('meeting')} {i18n.t('location')}({i18n.t('arabic')})
                        </label>
                        <input
                          type="text"
                          name="location_ar"
                          value={this.state.input.location_ar}
                          onChange={this.handleChange}
                          style={{ direction: 'rtl' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.location_ar}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('meeting')} {i18n.t('description')}
                        </label>
                        <textarea
                          placeholder={i18n.t('description')}
                          value={this.state.input.description}
                          name="description"
                          onChange={this.handleChange}
                          className="form-control rounded-1"
                          rows={3}
                        />
                        <div className="text-danger">{this.state.errors.location}</div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('meeting')} {i18n.t('description')}({i18n.t('arabic')})
                        </label>
                        <textarea
                          placeholder={i18n.t('description')}
                          value={this.state.input.description_ar}
                          name="description_ar"
                          onChange={this.handleChange}
                          style={{ direction: 'rtl' }}
                          className="form-control rounded-1"
                          rows={3}
                        />
                        <div className="text-danger">{this.state.errors.description_ar}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('meeting')} {i18n.t('description')} - {i18n.t('footer')}
                        </label>
                        <textarea
                          placeholder={i18n.t('description')}
                          value={this.state.input.footer_desc}
                          name="footer_desc"
                          onChange={this.handleChange}
                          className="form-control rounded-1"
                          rows={3}
                        />
                        <div className="text-danger">{this.state.errors.footer_desc}</div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('meeting')} {i18n.t('description')} - {i18n.t('footer')}({i18n.t('arabic')})
                        </label>
                        <textarea
                          placeholder={i18n.t('description')}
                          value={this.state.input.footer_desc_ar}
                          name="footer_desc_ar"
                          onChange={this.handleChange}
                          style={{ direction: 'rtl' }}
                          className="form-control rounded-1"
                          rows={3}
                        />
                        <div className="text-danger">{this.state.errors.footer_desc_ar}</div>
                      </div>
                    </div>

                    <div className="col-sm-6 col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('meeting')} {i18n.t('date')}
                        </label>
                        <input
                          type="date"
                          name="date"
                          value={this.state.input.date}
                          onChange={this.handleChange}
                          style={{ direction: 'ltr' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.date}</div>
                      </div>
                    </div>

                    <div className="col-sm-3 col-md-3">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('start')} {i18n.t('time')}
                        </label>
                        <input
                          type="time"
                          name="start_time"
                          value={this.state.input.start_time}
                          onChange={this.handleChange}
                          style={{ direction: 'ltr' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.start_time}</div>
                      </div>
                    </div>

                    <div className="col-sm-3 col-md-3">
                      <div className="form-group">
                        <label className="form-label">
                          {i18n.t('end')} {i18n.t('time')}
                        </label>
                        <input
                          type="time"
                          name="end_time"
                          value={this.state.input.end_time}
                          onChange={this.handleChange}
                          style={{ direction: 'ltr' }}
                          className="form-control custom-input "
                        />
                        <div className="text-danger">{this.state.errors.end_time}</div>
                      </div>
                    </div>
                  </div>

                  <button type="button" className="btn btn-primary btn-block mt-5" onClick={this.handleSubmit}>
                    {i18n.t('submit')}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default EditMeeting;
